import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import {Calendar} from "primereact/calendar";
import axios from "axios";

const ScheduleitemListComponent = (props) => {

  const {t, scheduleId, scheduleGroupType} = props;
  const history = useHistory();
  const {module, entity, action, id} = useParams();
  const [scheduleitems, setScheduleitems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusDict, setStatusDict] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [addDialogVisible, setAddDialogVisible] = useState(false);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [employeeQuery, setEmployeeQuery] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const [machineOptions, setMachineOptions] = useState([]);
  const [machineQuery, setMachineQuery] = useState('');
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [machineLoading, setMachineLoading] = useState(false);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateUntil, setDateUntil] = useState(null);
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  const getDateTimeValue = (value, currentValue) => {
    if (!value) return null;
    if (currentValue) return value;
    const date = new Date(value);
    date.setHours(0, 0, 0, 0);
    return date;
  };

  const emptyDateTimeViewDate = getDateTimeValue(new Date(), null);

  const clearFieldSearch = (sp, field) => {
    sp.delete(`search[${field}]`);
    sp.delete(`search[${field}][operator]`);
    sp.delete(`search[${field}][operator][]`);
    sp.delete(`search[${field}][value]`);
    sp.delete(`search[${field}][value][]`);
  };

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      const baseQuery = window.App.transformQueryParams(lazyParams) || '';
      const sp = new URLSearchParams(baseQuery.startsWith('?') ? baseQuery.slice(1) : baseQuery);
      clearFieldSearch(sp, 'schedule');
      if (scheduleId) {
        sp.set('search[schedule][operator]', '=');
        sp.set('search[schedule][value]', scheduleId);
      }
      const query = sp.toString() ? `?${sp.toString()}` : '';
      apiCall('get', '/api/v2/schedule-item' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setScheduleitems(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
      apiCall('get', '/api/v2/dictionary/production-status')
        .then(response => {
          setStatusDict(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/schedule-item/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderScheduleItemList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  const needsEmployee = ['EMPLOYEE_CAPACITY', 'MACHINE_EMPLOYEE_CAPACITY'].includes(scheduleGroupType);
  const needsMachine = ['MACHINE_CAPACITY', 'MACHINE_EMPLOYEE_CAPACITY'].includes(scheduleGroupType);

  const loadEmployeeOptions = () => {
    setEmployeeLoading(true);
    apiCall('get', '/api/v2/employee?item_per_page=9999')
      .then((response) => {
        const items = response?.data?.data?.items || [];
        setEmployeeOptions(items.map((item) => ({
          ...item,
          displayName: item.name || `${item.last_name || ''} ${item.first_name || ''}`.trim() || `#${item.id}`
        })));
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setEmployeeLoading(false);
      });
  };

  const loadMachineOptions = () => {
    setMachineLoading(true);
    apiCall('get', '/api/v2/machine?item_per_page=9999')
      .then((response) => {
        const items = response?.data?.data?.items || [];
        setMachineOptions(items.map((item) => ({
          ...item,
          displayName: item.name || `#${item.id}`
        })));
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setMachineLoading(false);
      });
  };

  const saveScheduleItem = () => {
    if (!scheduleId) {
      window.App.toastShow('error', 'Hiba', 'Hiányzó műszak azonosító.');
      return;
    }
    if (needsEmployee && !selectedEmployee?.id) {
      window.App.toastShow('error', 'Hiba', 'A munkavállaló kiválasztása kötelező.');
      return;
    }
    if (needsMachine && !selectedMachine?.id) {
      window.App.toastShow('error', 'Hiba', 'A berendezés kiválasztása kötelező.');
      return;
    }
    const payload = {
      schedule: Number(scheduleId),
      ...(props.scheduleGroupId ? { schedule_group: Number(props.scheduleGroupId) } : {}),
      ...(dateFrom ? { date_from: dateFrom.toISOString() } : {}),
      ...(dateUntil ? { date_until: dateUntil.toISOString() } : {}),
      ...(needsEmployee ? { employee: Number(selectedEmployee.id) } : {}),
      ...(needsMachine ? { machine: Number(selectedMachine.id) } : {})
    };
    setLoading(true);
    apiCall('post', '/api/v2/schedule-item', payload)
      .then(() => {
        setAddDialogVisible(false);
        setSelectedEmployee(null);
        setSelectedMachine(null);
        setDateFrom(null);
        setDateUntil(null);
        window.App.toastShow('success', 'Sikeres mentés!');
        window.App.setState({rerenderScheduleItemList: Math.random()});
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formatScheduleItemDateRange = (dateFrom, dateUntil) => {
    if (!dateFrom || !dateUntil) {
      return '-';
    }
    return `${window.App.formatDateValue(dateFrom)} - ${window.App.formatDateValue(dateUntil)}`;
  };

  const translateStatus = (key) => {
    const found = statusDict.find((x) => x.key === key);
    return found ? found.value : key;
  };

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, scheduleId, window.App.state.rerenderScheduleItemList])

  return (
    <>
      <div className="p-mb-3 p-text-right">
        <Button
          type="button"
          label={t('addEntry')}
          icon="pi pi-plus"
          className="p-button-success"
          onClick={() => {
            setSelectedEmployee(null);
            setSelectedMachine(null);
            setEmployeeQuery('');
            setMachineQuery('');
            setDateFrom(null);
            setDateUntil(null);
            if (needsEmployee) {
              loadEmployeeOptions();
            }
            if (needsMachine) {
              loadMachineOptions();
            }
            setAddDialogVisible(true);
          }}
        />
      </div>

      <Dialog
        header={t('addEntry')}
        visible={addDialogVisible}
        style={{ width: '520px' }}
        modal
        onHide={() => setAddDialogVisible(false)}
        footer={
          <div>
            <Button
              type="button"
              label="Mégse"
              icon="pi pi-times"
              className="p-button"
              onClick={() => setAddDialogVisible(false)}
            />
            <Button
              type="button"
              label="Mentés"
              icon="pi pi-save"
              className="p-button-success"
              loading={loading}
              onClick={saveScheduleItem}
            />
          </div>
        }
      >
        {needsEmployee && (
          <div className="p-field p-fluid p-mb-3">
            <label>{t('columnEmployee')}</label>
            <Dropdown
              value={selectedEmployee?.id || null}
              options={employeeOptions}
              optionLabel="displayName"
              optionValue="id"
              filter
              showClear
              loading={employeeLoading}
              placeholder={t('selectPlaceholder')}
              emptyMessage={t('noResults')}
              emptyFilterMessage={t('noResults')}
              onChange={(e) => {
                const employee = employeeOptions.find(item => Number(item.id) === Number(e.value)) || null;
                setSelectedEmployee(employee);
              }}
            />
          </div>
        )}

        {needsMachine && (
          <div className="p-field p-fluid p-mb-3">
            <label>{t('columnEquipment')}</label>
            <Dropdown
              value={selectedMachine?.id || null}
              options={machineOptions}
              optionLabel="displayName"
              optionValue="id"
              filter
              showClear
              loading={machineLoading}
              placeholder={t('selectPlaceholder')}
              emptyMessage={t('noResults')}
              emptyFilterMessage={t('noResults')}
              onChange={(e) => {
                const machine = machineOptions.find(item => Number(item.id) === Number(e.value)) || null;
                setSelectedMachine(machine);
              }}
            />
          </div>
        )}
        <div className="p-field p-fluid p-mb-3">
          <label>{t('columnStart')}</label>
          <Calendar
            value={dateFrom}
            viewDate={!dateFrom ? emptyDateTimeViewDate : null}
            onChange={(e) => setDateFrom(getDateTimeValue(e.value, dateFrom))}
            showTime
            showIcon
            hourFormat="24"
            dateFormat="yy-mm-dd"
          />
        </div>

        <div className="p-field p-fluid p-mb-3">
          <label>{t('columnEnd')}</label>
          <Calendar
            value={dateUntil}
            viewDate={!dateUntil ? emptyDateTimeViewDate : null}
            onChange={(e) => setDateUntil(getDateTimeValue(e.value, dateUntil))}
            showTime
            showIcon
            hourFormat="24"
            dateFormat="yy-mm-dd"
          />
        </div>
      </Dialog>

      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={scheduleitems} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column  header={t('columnAssigned')} sortable body={(rowData) => {
          return (
            <>{formatScheduleItemDateRange(rowData.date_from, rowData.date_until)}</>
          )
        }}></Column>
        {['EMPLOYEE_CAPACITY', 'MACHINE_EMPLOYEE_CAPACITY'].includes(props.scheduleGroupType) && (
          <Column field="employee.name" header={t('columnEmployee')} sortable filter></Column>
        )}
        {['MACHINE_CAPACITY', 'MACHINE_EMPLOYEE_CAPACITY'].includes(props.scheduleGroupType) && (
          <Column field="machine.name" header={t('columnEquipment')} sortable filter></Column>
        )}
        <Column header={t('columnTasks')} body={(rowData) => {
          const jobs = rowData?.production_jobs || [];
          if (!jobs.length) {
            return <>-</>;
          }
          return (
            <div>
              {jobs.map((job, index) => (
                <div key={job.id || index} className="p-mb-2">
                  <div>
                    <strong>{job.project_number}</strong>
                  </div>
                  <div>
                    {job?.technology?.name || '-'}
                  </div>
                  <div>
                    {t('columnStatus')}: {translateStatus(job?.status) || '-'}
                  </div>
                  <div>
                    {job?.quantity || '-'} {job?.unit?.name || ''}
                  </div>
                  {job?.standard_time !== null && job?.standard_time !== undefined && (
                    <div>
                      {t('columnStandardTime')}: {job.standard_time}
                    </div>
                  )}
                </div>
              ))}
            </div>
          );
        }}></Column>
        


        {/* <Column field="updated_at" header="Módosítva" sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column> */}
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ScheduleitemListComponent);
